export default {
  namespaced: true,
  state: {
    // 风险级别
    riskLevel: [
      {
        idIndex: 0,
        levelNameOne: "低风险",
        levelNameTwo: "Ⅳ级",
        backgroundColor: "#0000FF",
        color: "#fff",
        className: "risk_level_four",
        classNameTwo: "risk_level_four_two",
        hazardIndexStart: 0, // 危险指数最低分
        hazardIndexEnd: 70, // 危险指数最高分
        lsHazardIndexStart: 0,
        lsHazardIndexEnd: 3
      },
      {
        idIndex: 1,
        levelNameOne: "一般风险",
        levelNameTwo: "Ⅲ级",

        backgroundColor: "#FFFF00",
        color: "#000",

        className: "risk_level_three",
        classNameTwo: "risk_level_three_two",
        hazardIndexStart: 71, // 危险指数最低分
        hazardIndexEnd: 160, // 危险指数最高分
        lsHazardIndexStart: 4,
        lsHazardIndexEnd: 8
      },
      {
        idIndex: 2,
        levelNameOne: "较大风险",
        levelNameTwo: "Ⅱ级",
        backgroundColor: "#ff6100",
        color: "#000",

        className: "risk_level_two",
        classNameTwo: "risk_level_two_two",
        hazardIndexStart: 161, // 危险指数最低分
        hazardIndexEnd: 320, // 危险指数最高分
        lsHazardIndexStart: 9,
        lsHazardIndexEnd: 12
      },
      {
        idIndex: 3,
        levelNameOne: "重大风险",
        levelNameTwo: "Ⅰ级",
        backgroundColor: "#FF0000",
        color: "#000",
        className: "risk_level_one",
        classNameTwo: "risk_level_one_two",
        hazardIndexStart: 321, // 危险指数最低分
        hazardIndexEnd: 5000, // 危险指数最高分
        lsHazardIndexStart: 16,
        lsHazardIndexEnd: 16
      }
    ],

    // 风险级别表格列样式名称
    riskLevelTableName: "table_resk_level_col",

    // 审核状态
    examineState: [
      { id: 0, name: "未审核" },
      { id: 1, name: "已审核，审核通过" },
      { id: 2, name: "已审核，已重新评定" }
    ],
    // 管控级别
    controlLevel: [
      { id: 0, name: "请选择" },
      { id: 1, name: "校(园)级" },
      { id: 2, name: "副校(园)级" },
      { id: 3, name: "处级(科级、科室级、处科级)" },
      { id: 4, name: "岗位责任人(责任人)" }
    ],
    // 检查频次
    inspectionFrequency: [
      { id: 0, name: "实时检查" },
      { id: 1, name: "日" },
      { id: 2, name: "周" },
      { id: 3, name: "月" },
      { id: 4, name: "季度" },
      { id: 5, name: "学期" },
      { id: 6, name: "年" }
    ],
    inspectionStatus: [
      {
        id: 0,
        name: "正常"
      },
      {
        id: 1,
        name: "异常"
      }
    ],

    // 权限状态
    authorityStatus: {
      0: "禁用",
      1: "启用"
    },

    // 建筑物/活动
    buildingOrActivity: {
      0: "教育教学活动",
      1: "设施设备及区域"
    },

    // 建筑物/活动
    buildingOrActivity: [
      {
        id: 0,
        name: "教育教学活动"
      },
      {
        id: 1,
        name: "设施设备及区域"
      }
    ],

    // 评估类型
    assessmentType: [
      { id: 0, name: "风险矩阵法（LS）" },
      { id: 1, name: "教学条件危险性分析评价法（LEC）" }
    ],

    // 评估方法
    assessmentMethod: [
      // 风险矩阵法（LS）
      {
        // 风险矩阵法可能性
        lsl: [
          { fraction: 0, name: "请选择" },
          {
            fraction: 1,
            name:
              "有充分、有效的防范、控制、监测、保护措施，管理人员安全意识相高，严格执行操作规程。极不可能发生安全事故。"
          },
          {
            fraction: 2,
            name:
              "现场有防范控制措施，如发生安全事故，能有效控制，发生安全事故的可能性很小。"
          },
          {
            fraction: 3,
            name:
              "现场有防范、监测、保护、控制措施，但管理人员未有效执行或控制措施不当，可能发生安全事故。"
          },
          {
            fraction: 4,
            name:
              "现场有采取防范、监测、保护、控制措施，曾经发生过安全事故，安全管理不规范，发生安全事故的可能性极大。"
          }
        ],
        // 风险矩阵法严重性
        lss: [
          { fraction: 0, name: "请选择" },
          {
            fraction: 1,
            name: "不符合安全管理要求，能造成设备损坏或造成1万元以下经济损失。"
          },
          {
            fraction: 2,
            name: "能造成人员轻度受伤或造成1万元以上10万元以下经济损失。"
          },
          {
            fraction: 3,
            name:
              "能造成人员骨折、慢性病等严重伤害或造成10万元以上50万元以下经济损失。"
          },
          { fraction: 4, name: "能造成人员伤亡或造成50万元以上经济损失。" }
        ]
      },
      // 教学条件危险性分析评价法（LEC）
      {
        // 分析评价法可能性
        lecl: [
          { fraction: 0, name: "请选择" },
          {
            fraction: 1,
            name:
              "可能性小，完全意外；或危害的发生容易被发现；现场有监测系统或曾经作过监测；或过去曾经发生类似事故、事件；或在异常情况下发生过类似事故、事件。"
          },
          {
            fraction: 3,
            name:
              "可能，但不经常；或危害的发生不容易被发现；现场有检测系统或保护措施，在现场有控制措施，但未有效执行或控制措施不当。"
          },
          {
            fraction: 6,
            name:
              "相当可能，危害的发生不能被发现；在现场没有采取防范、监测、保护、控制措施；在正常情况下经常发生此类事故、事件。"
          },
          { fraction: 10, name: "完全可以预料。" }
        ],
        // 分析评价法频繁程度
        lece: [
          { fraction: 0, name: "请选择" },
          { fraction: 0.5, name: "非常罕见的暴露" },
          { fraction: 1, name: "每年几次暴露" },
          { fraction: 2, name: "每月一次暴露" },
          { fraction: 3, name: "每周一次或偶然暴露" },
          { fraction: 6, name: "每天工作时间内暴露" },
          { fraction: 10, name: "连续暴露" }
        ],
        // 分析评价法严重性
        lecc: [
          { fraction: 0, name: "请选择" },
          {
            fraction: 10,
            name: "不符合安全管理要求，能造成设备损坏或造成1万元以下经济损失。"
          },
          {
            fraction: 20,
            name: "能造成人员轻度受伤或造成1万元以上10万元以下经济损失。"
          },
          {
            fraction: 30,
            name:
              "能造成人员骨折、慢性病等严重伤害或造成10万元以上50万元以下经济损失。"
          },
          { fraction: 50, name: "能造成人员伤亡或造成50万元以上经济损失。" }
        ]
      }
    ],

    // 任务状态
    taskState: {
      0: "进行中",
      1: "已完成"
    },

    // 二维码类型
    qrCodeType: [
      { id: 0, name: "静态二维码", nameTwo: "静态二维码(固定不变)" },
      {
        id: 1,
        name: "动态二维码",
        nameTwo: "动态二维码(巡查二维码每小时更新一次)"
      }
    ],

    // 巡查类型
    patrolType: [
      { id: 0, name: "暂未关联" },
      { id: 1, name: "日常巡查" },
      { id: 2, name: "设备巡查" }
    ],

    // 固定的下载内容
    downloadFileData: {
      patrolRegionTemplate: "files/20200511/inspection.xlsx", //巡查区域模版
      healthTemplate: "files/20200918/健康排查表.xlsx" //健康排查表
    },

    // 星期列表
    weekList: [
      { id: 1, name: "周一", selectedStatus: false },
      { id: 2, name: "周二", selectedStatus: false },
      { id: 3, name: "周三", selectedStatus: false },
      { id: 4, name: "周四", selectedStatus: false },
      { id: 5, name: "周五", selectedStatus: false },
      { id: 6, name: "周六", selectedStatus: false },
      { id: 7, name: "周日", selectedStatus: false }
    ],

    // 任务类型
    taskType: [
      { id: 1, name: "自定义任务" },
      { id: 2, name: "周任务" },
      { id: 3, name: "月任务" },
      { id: 4, name: "季度任务" },
      { id: 5, name: "学期任务" }
    ],

    // 检查项状态
    checkItemStatus: [
      {
        id: 0,
        nameOne: "异常",
        nameTwo: "异常",
        nameThree: "已检查",
        typeClass: "success",
        isCheck: false
      },
      {
        id: 1,
        nameOne: "正常（默认）",
        nameTwo: "正常",
        nameThree: "未检查",
        typeClass: "danger",
        isCheck: false
      }
    ],

    // 任务时间类型
    taskTimeType: [
      {
        id: 0,
        nameOne: "指定具体日期、时间段完成",
        nameTwo: "指定具体日期、时间段完成",
        isCheck: false,
        taskTimeTypeList: [
          { id: 0, nameOne: "自定义任务" },
          { id: 1, nameOne: "周任务" },
          { id: 2, nameOne: "月任务" }
        ]
      },
      {
        id: 1,
        nameOne: "指定时间区间，全天任意时间均可完成",
        nameTwo: "指定时间区间，全天任意时间均可完成",
        isCheck: false,
        taskTimeTypeList: [
          { id: 1, nameOne: "周任务" },
          { id: 2, nameOne: "月任务" },
          { id: 3, nameOne: "季度任务" },
          { id: 4, nameOne: "学期任务" }
        ]
      }
    ],
    // 巡查人员类型
    typeOfInspector: [
      { id: 0, nameOne: "一个人扫码则所有人完成" },
      { id: 1, nameOne: "必须所有人扫码才视为完成" }
    ],

    // 月数据
    monthData: [
      { id: 0, name: "01", monthNumber: 1 },
      { id: 1, name: "02", monthNumber: 2 },
      { id: 2, name: "03", monthNumber: 3 },
      { id: 3, name: "04", monthNumber: 4 },
      { id: 4, name: "05", monthNumber: 5 },
      { id: 5, name: "06", monthNumber: 6 },
      { id: 6, name: "07", monthNumber: 7 },
      { id: 7, name: "08", monthNumber: 8 },
      { id: 8, name: "09", monthNumber: 9 },
      { id: 9, name: "10", monthNumber: 10 },
      { id: 10, name: "11", monthNumber: 11 },
      { id: 11, name: "12", monthNumber: 12 },
      { id: 12, name: "13", monthNumber: 13 },
      { id: 13, name: "14", monthNumber: 14 },
      { id: 14, name: "15", monthNumber: 15 },
      { id: 15, name: "16", monthNumber: 16 },
      { id: 16, name: "17", monthNumber: 17 },
      { id: 17, name: "18", monthNumber: 18 },
      { id: 18, name: "19", monthNumber: 19 },
      { id: 19, name: "20", monthNumber: 20 },
      { id: 20, name: "21", monthNumber: 21 },
      { id: 21, name: "22", monthNumber: 22 },
      { id: 22, name: "23", monthNumber: 23 },
      { id: 23, name: "24", monthNumber: 24 },
      { id: 24, name: "25", monthNumber: 25 },
      { id: 25, name: "26", monthNumber: 26 },
      { id: 26, name: "27", monthNumber: 27 },
      { id: 27, name: "28", monthNumber: 28 },
      { id: 28, name: "29", monthNumber: 29 },
      { id: 29, name: "30", monthNumber: 30 },
      { id: 30, name: "31", monthNumber: 31 }
    ],

    // 巡查状态
    patrolState: [
      { id: 0, name: "待巡查" },
      { id: 1, name: "已巡查" },
      { id: 2, name: "已过期" }
    ],

    // 事故处理状态
    accidentHandlingStatus: [
      { id: 0, nameOne: "请选择" },
      { id: 1, nameOne: "新填报" },
      { id: 2, nameOne: "已处理" },
      { id: 3, nameOne: "已结案" }
    ],

    // 事故等级
    accidentLevel: [
      { id: 0, nameOne: "请选择事故等级" },
      { id: 1, nameOne: "特别重大事故" },
      { id: 2, nameOne: "重大事故" },
      { id: 3, nameOne: "较大事故" },
      { id: 4, nameOne: "一般事故" }
    ],

    // 事故分类
    accidentClassification: [
      { id: 0, nameOne: "请选择事故分类" },
      { id: 1, nameOne: "交通事故" },
      { id: 2, nameOne: "踩踏事故" },
      { id: 3, nameOne: "溺水事故" },
      { id: 4, nameOne: "火灾事故" },
      { id: 5, nameOne: "触电事故" },
      { id: 6, nameOne: "校园伤害" },
      { id: 7, nameOne: "其它" }
    ],
    // 事故性质
    accidentNature: [
      { id: 0, nameOne: "请选择事故性质" },
      { id: 1, nameOne: "责任事故" },
      { id: 2, nameOne: "自然事故" },
      { id: 3, nameOne: "技术事故" },
      { id: 4, nameOne: "其它" }
    ],

    // 隐患来源
    hiddenDangerSource: [
      { id: 0, nameOne: "社会监督" },
      { id: 1, nameOne: "隐患排查" },
      { id: 2, nameOne: "日常检查" },
      { id: 3, nameOne: "专项检查" }
      // {id:4,nameOne:'其它'},
    ],
    // 隐患等级
    hiddenDangerLevel: [
      // { id: 0, nameOne: "低隐患" },
      { id: 1, nameOne: "一般隐患" },
      // { id: 2, nameOne: "较大隐患" },
      { id: 3, nameOne: "重大隐患" }
    ],
    // 隐患类型
    hiddenDangerType: [
      { id: 1, nameOne: "地质灾害" },
      { id: 2, nameOne: "卫生食品 " },
      { id: 3, nameOne: "人身安全" },
      { id: 4, nameOne: "宿舍、设施、设备" },
      { id: 5, nameOne: "水、电" }
    ],

    // 隐患状态
    hiddenDangerStatus: [
      { id: 0, nameOne: "已上报", nameTwo: "上报待指派" },
      { id: 1, nameOne: "已指派", nameTwo: "已指派" },
      { id: 2, nameOne: "已处理", nameTwo: "已处理" },
      { id: 3, nameOne: "已撤销", nameTwo: "已撤销" },
      { id: 4, nameOne: "已验收", nameTwo: "已验收" },
      { id: 5, nameOne: "已过期", nameTwo: "已过期"},
      // {id:6,nameOne:'其它2'},
    ],

    // 督办状态
    supervisionStatus: [
      { id: 1, name: "正在督办" },
      { id: 2, name: "督办完成" }
    ],

    // 流水状态
    flowState: [
      { id: 0, nameOne: "上报给", nameTwo: "上报给" },
      { id: 1, nameOne: "已指派给", nameTwo: "已指派" },
      { id: 2, nameOne: "已处理", nameTwo: "已处理" },
      { id: 3, nameOne: "重新指派给", nameTwo: "重新指派给" },
      { id: 4, nameOne: "已验收", nameTwo: "已验收" },
      { id: 5, nameOne: "已撤销该隐患", nameTwo: "已撤销该隐患" },
      { id: 6, nameOne: "已重新指派", nameTwo: "已重新指派" },
      { id: 7, nameOne: "已转派", nameTwo: "已转派" }
    ],

    // 学校类别
    schoolCategory: [
      { id: 0, nameOne: "幼儿园" },
      { id: 1, nameOne: "小学" },
      { id: 2, nameOne: "中学" },
      { id: 3, nameOne: "高中" },
      { id: 4, nameOne: "大学" },
      { id: 5, nameOne: "其他" }
    ],

    // 办学类型
    schoolType: [
      { id: 0, nameOne: "公办" },
      { id: 1, nameOne: "集体办" },
      { id: 2, nameOne: "民办" },
      { id: 3, nameOne: "其他" }
    ],

    // 广播品牌
    broadcastBrand: [
      { id: 0, name: "智慧广播" },
      { id: 1, name: "云广播" }
    ],

    // 广播类型
    broadcastType: [
      { id: 0, nameOne: "普通广播" },
      { id: 1, nameOne: "应急广播" }
    ],

    // 广播类型
    broadcastClassification: [
      { id: 0, name: "通知公告" },
      { id: 1, name: "安全教育" },
      { id: 2, name: "校园文化" },
      { id: 3, name: "作息铃声" },
      { id: 4, name: "其它广播" }
    ],

    // 广播时间段类型
    broadcastTimeType: [
      { id: 0, name: "上课时间" },
      { id: 1, name: "课外时间" },
      { id: 2, name: "广播时间" }
    ],

    // 应用场景
    sceneList: [
      { id: 0, name: "正常" },
      { id: 1, name: "晴天 " },
      { id: 2, name: "雨雪天 " },
      { id: 3, name: "小考试" },
      { id: 4, name: "大考试" },
      { id: 5, name: "运动会" }
    ],

    // 问卷调查完成详情状态
    finishState: [
      { id: 0, nameOne: "未提交" },
      { id: 1, nameOne: "已提交" }
    ],

    // 救援器材状态
    rescueEquipmentStatus: [
      { id: 0, nameOne: "全新", nameTwo: "全新" },
      { id: 1, nameOne: "完好", nameTwo: "完好" },
      { id: 2, nameOne: "已损坏", nameTwo: "已损坏" },
      { id: 3, nameOne: "已报废", nameTwo: "已报废" }
    ],

    // 演练状态
    drillStatus: [
      { id: 0, nameOne: "未启动", nameTwo: "未启动" },
      { id: 1, nameOne: "已启动", nameTwo: "已启动" }
    ],

    // 预案类型
    planType: [
      { id: 0, nameOne: "地震应急预案", nameTwo: "地震应急预案" },
      { id: 1, nameOne: "火灾应急预案", nameTwo: "火灾应急预案" },
      { id: 2, nameOne: "传染病应急预案", nameTwo: "传染病应急预案" },
      { id: 3, nameOne: "食物中毒应急预案", nameTwo: "食物中毒应急预案" },
      { id: 4, nameOne: "校园踩踏应急预案", nameTwo: "校园踩踏应急预案" },
      { id: 5, nameOne: "防恐防暴应急预案", nameTwo: "防恐防暴应急预案" },
      { id: 6, nameOne: "极端天气应急预案", nameTwo: "极端天气应急预案" },
      { id: 7, nameOne: "突发事件应急预案", nameTwo: "突发事件应急预案" },
      { id: 8, nameOne: "防汛应急预案", nameTwo: "防汛应急预案" },
      { id: 9, nameOne: "其他预案", nameTwo: "其他预案" }
    ],

    // 预案等级
    planLevel: [
      { id: 0, nameOne: "一般级别", nameTwo: "一般级别" },
      { id: 1, nameOne: "较紧急级别", nameTwo: "较紧急级别" },
      { id: 2, nameOne: "非常紧急级别", nameTwo: "非常紧急级别" },
      { id: 3, nameOne: "特别紧急级别", nameTwo: "特别紧急级别" }
    ],

    // 演练内容类型
    drillContentType: [
      { id: 0, nameOne: "演练启动", nameTwo: "演练启动" },
      { id: 1, nameOne: "应急广播", nameTwo: "应急广播" },
      { id: 2, nameOne: "应急喊话", nameTwo: "应急喊话" },
      { id: 3, nameOne: "演练直播", nameTwo: "演练直播" },
      { id: 4, nameOne: "演练结束", nameTwo: "演练结束" }
    ],

    situationMenu: [
      {
        id: 0,
        nameOne: "基础信息",
        nameTwo: "校园基础信息",
        icon: "img/icon_situation.png",
        path: "/basic_information"
      },
      {
        id: 1,
        nameOne: "风险隐患",
        nameTwo: "校园风险隐患",
        icon: "img/icon_doubleprevention.png",
        path: "/rotential_risks"
      },
      {
        id: 2,
        nameOne: "雪亮工程",
        nameTwo: "校园雪亮工程",
        icon: "img/icon_aqcenter.png",
        path: "/monitoring_center"
      },
      {
        id: 3,
        nameOne: "安全地图",
        nameTwo: "校园安全地图",
        icon: "img/icon_map.png",
        path: "/safety_map"
      },
      {
        id: 4,
        nameOne: "食品安全",
        nameTwo: "校园食品安全",
        icon: "img/icon_foodsafety.png",
        path: "/food_safety"
      }
    ],

    // 食材分类
    ingredientsType: [
      { id: 0, nameOne: "肉类", nameTwo: "肉类", color: "#6556FF" },
      { id: 1, nameOne: "蔬菜", nameTwo: "蔬菜", color: "#00E08F" },
      { id: 2, nameOne: "水果", nameTwo: "水果", color: "#FF5B95" },
      { id: 3, nameOne: "饮品", nameTwo: "饮品", color: "#AFEEEE" },
      { id: 4, nameOne: "豆制品", nameTwo: "豆制品", color: "#F2F2F2" },
      { id: 5, nameOne: "调味品", nameTwo: "调味品", color: "#FAEF18" },
      { id: 6, nameOne: "水产品", nameTwo: "水产品", color: "#038AFC" },
      { id: 7, nameOne: "食用油", nameTwo: "食用油", color: "#FD8C32" },
      {
        id: 8,
        nameOne: "粮谷类(米、面)",
        nameTwo: "粮谷类(米、面)",
        color: "#fff"
      },
      { id: 9, nameOne: "其他", nameTwo: "其他", color: "#DD5145" }
    ],

    // 食材计量单位
    ingredientsUnit: [
      { id: 0, name: "克" },
      { id: 1, name: "千克" },
      { id: 2, name: "斤" },
      { id: 3, name: "升" },
      { id: 4, name: "毫升" },
      { id: 5, name: "袋" },
      { id: 6, name: "个" },
      { id: 7, name: "件" },
      { id: 8, name: "盒" }
    ],

    // 餐厅评分等级
    restaurantRating: [
      { id: 0, nameOne: "A优秀", nameTwo: "A", icon: "/img/icon_perfect.png" },
      { id: 1, nameOne: "B良好", nameTwo: "B", icon: "/img/icon_good.png" },
      { id: 2, nameOne: "C一般", nameTwo: "C", icon: "/img/icon_soso.png" }
    ],

    // 安全态势显示类型
    dataPictureDisplayType: [
      { id: 0, nameOne: "显示3D平面图" },
      { id: 1, nameOne: "显示平面图" }
    ],

    // 监控品牌
    monitorBrand: [
      { id: 0, nameOne: "乐橙" },
      { id: 1, nameOne: "萤石" },
      {id:2,nameOne:'大华'},
      {id:3,nameOne:'大华U8100'},
      {id:4,nameOne:'海康'},
      {id:5,nameOne:'视频联网智能感知系统'}
    ],

    // 设备品牌
    equipmentBrand: [
      { id: 0, nameOne: "乐橙" },
      { id: 1, nameOne: "萤石" },
      {id:2,nameOne:'大华'},
      {id:3,nameOne:'大华U8100'},
      {id:4,nameOne:'海康'},
      {id:5,nameOne:'博观'}
    ],

    // 人员类型
    personnelType: [
      { id: 0, nameOne: "校内人员" },
      { id: 1, nameOne: "外聘人员" }
    ],

    // 人员性别
    personnelSex: [
      { id: 0, nameOne: "男" },
      { id: 1, nameOne: "女" }
    ],

    // 人员性别(疫情防控健康排查表专用)
    personnelSexTwo: [
      { id: 1, nameOne: "男" },
      { id: 2, nameOne: "女" }
    ],

    // 消防器材类型
    fireEquipmentType: [
      { id: 0, nameOne: "灭火器" },
      { id: 1, nameOne: "灭火毯" },
      { id: 2, nameOne: "消火栓" },
      { id: 3, nameOne: "其它" },
      { id: 4, nameOne: "安全通道" }
    ],

    // 消防器材类型
    fireEquipmentStatue: [
      { id: 0, nameOne: "完好无损" },
      { id: 1, nameOne: "已损坏" }
    ],

    // 知识类别
    knowledgeCategory: [
      { id: 0, nameOne: "读一读" },
      { id: 1, nameOne: "看一看" },
      { id: 2, nameOne: "听一听" },
      { id: 3, nameOne: "玩一玩" }
    ],
    // 学籍数据
    studentStatus: [
      {
        id: 0,
        name: "幼儿园",
        list: [
          { id: 0, name: "小班" },
          { id: 1, name: "中班" },
          { id: 2, name: "大班" }
        ]
      },
      {
        id: 1,
        name: "小学",
        list: [
          { id: 0, name: "一年级" },
          { id: 1, name: "二年级" },
          { id: 2, name: "三年级" },
          { id: 3, name: "四年级" },
          { id: 4, name: "五年级" },
          { id: 5, name: "六年级" }
        ]
      },
      {
        id: 2,
        name: "初中",
        list: [
          { id: 0, name: "初一" },
          { id: 1, name: "初二" },
          { id: 2, name: "初三" }
        ]
      },
      {
        id: 3,
        name: "高中",
        list: [
          { id: 0, name: "高一" },
          { id: 1, name: "高二" },
          { id: 2, name: "高三" }
        ]
      },
      {
        id: 4,
        name: "大学",
        list: [
          { id: 0, name: "大一" },
          { id: 1, name: "大二" },
          { id: 2, name: "大三" },
          { id: 2, name: "大四" }
        ]
      }
    ],
    // 聊天群
    chatGroup: [
      { id: 0, nameOne: "是" },
      { id: 1, nameOne: "否" }
    ],

    // (是否特异体质)
    yesOrNo: [
      { id: 0, nameOne: "否" },
      { id: 1, nameOne: "是" }
    ],

    // 绑定家长状态
    parentBindingStatus: [
      { id: 0, nameOne: "未绑定家长" },
      { id: 1, nameOne: "已绑定家长" }
    ],

    // 开启状态
    openState: [
      { id: 0, nameOne: "未开启" },
      { id: 1, nameOne: "已开启" }
    ],

    // 权限类别
    authorityCategory: [
      { id: 0, nameOne: "PC端访问权限" },
      { id: 1, nameOne: "APP应用权限" }
    ],

    // 签到状态
    signInStatus: [
      { id: 0, nameOne: "已签到" },
      { id: 1, nameOne: "未签到" }
    ],

    // 会议状态
    meetingStatus: [
      { id: 0, nameOne: "未开始" },
      { id: 1, nameOne: "已开始" },
      { id: 2, nameOne: "进行中" },
      { id: 3, nameOne: "已结束" }
    ],

    // 来访状态
    visitingStatus: [
      { id: 0, name: "待确认" },
      { id: 1, name: "已同意" },
      { id: 2, name: "已取消" },
      { id: 3, name: "已过期" }
    ],

    // 预约状态
    appointmentStatus: [
      { id: 0, nameOne: "已同意" },
      { id: 1, nameOne: "待确认" },
      { id: 2, nameOne: "已取消" }
    ],

    // 心理健康类型
    mentalHealthType: [
      { id: 0, nameOne: "情绪失控，伤人伤己" },
      { id: 1, nameOne: "情绪暴躁，扰乱秩序" },
      { id: 2, nameOne: "情绪亢奋，招惹他人" },
      { id: 3, nameOne: "其它" }
    ],

    // 学生与家长关系
    relationList: [
      { id: 0, nameOne: "母女" },
      { id: 1, nameOne: "母子" },
      { id: 2, nameOne: "父子" },
      { id: 3, nameOne: "父女" },
      { id: 4, nameOne: "其他" }
    ],

    // 事件等级
    eventLevel: [
      { id: 0, nameOne: "一般" },
      { id: 1, nameOne: "严重紧急" }
    ],

    // 父母外出情况
    parentSituation: [
      { id: 0, nameOne: "父亲外出" },
      { id: 1, nameOne: "母亲外出" },
      { id: 2, nameOne: "父母均外出" }
    ],

    // 家访类型
    homeVisitType: [
      { id: 0, nameOne: "电话沟通" },
      { id: 1, nameOne: "到家家访" }
    ],

    // 家访状态
    homeVisitStatus: [
      { id: 0, nameOne: "待处理" },
      { id: 1, nameOne: "已完成" }
    ],

    // 学生类型
    studentTypeList: [
      { id: 0, nameOne: "普通学生" },
      { id: 1, nameOne: "留守儿童学生" },
      { id: 2, nameOne: "特殊体质学生" }
    ],

    // 餐厅经营模式
    canteenManagementPattern: [
      { id: 0, nameOne: "自主经营" },
      { id: 1, nameOne: "对外承包" },
      { id: 2, nameOne: "配餐" },
      { id: 3, nameOne: "其它" }
    ],

    // 气体类型
    gasType: [
      { id: 0, nameOne: "天然气（管道煤气）" },
      { id: 1, nameOne: "瓶装气" },
      { id: 2, nameOne: "电磁炉" },
      { id: 3, nameOne: "气电合用" },
      { id: 4, nameOne: "其他" }
    ],

    // 检查等级
    inspectLevel: [
      { id: 0, nameOne: "A" },
      { id: 1, nameOne: "B" },
      { id: 2, nameOne: "C" }
    ],

    // 安全教育计划状态
    planningStatus: [
      { id: 0, nameOne: "未上报" },
      { id: 1, nameOne: "未审核" },
      { id: 2, nameOne: "未开始的计划" },
      { id: 3, nameOne: "审核不通过" },
      { id: 4, nameOne: "进行中的计划" },
      { id: 5, nameOne: "结束的计划" }
    ],

    // 安全教育计划类型
    planningType: [
      { id: 0, nameOne: "应急演练" },
      { id: 1, nameOne: "安全课堂" },
      { id: 2, nameOne: "安全广播" },
      { id: 3, nameOne: "安全巡查" }
    ],

    // 安全教育计划时间类型
    planningDateType: [
      { id: 0, nameOne: "年度计划" },
      { id: 1, nameOne: "季度计划" },
      { id: 2, nameOne: "周计划" }
    ],

    staffCertificateStatus: [
      { id: 0, nameOne: "未过期" },
      { id: 1, nameOne: "即将过期" },
      { id: 2, nameOne: "已过期" }
    ],

    // 禁用启用状态
    disableEnableStatus: [
      { id: 0, nameOne: "禁用" },
      { id: 1, nameOne: "启用" }
    ],

    // 处理状态
    processingStatus: [
      { id: 0, nameOne: "未处理" },
      { id: 1, nameOne: "已处理" }
    ],

    // 告警类型
    alarmType: [
      { id: 0, nameOne: "线路断电报警" },
      { id: 1, nameOne: "线路过流报警" },
      { id: 2, nameOne: "现场温度过低报警" },
      { id: 3, nameOne: "现场温度过高报警" }
    ],

    // 专项任务检查状态
    specialTaskStatus: [
      { id: 0, nameOne: "未检查" },
      { id: 1, nameOne: "待审核" },
      { id: 2, nameOne: "已过期" },
      { id: 3, nameOne: "待督办" },
      { id: 4, nameOne: "督办完成" }
    ],

    // 一键报警报警状态
    userAlarmType: [
      { id: 0, nameOne: "电话报警" },
      { id: 1, nameOne: "视频报警" }
    ],

    statisticsTimeList: [
      { id: 0, name: "年度统计" },
      { id: 1, name: "季度统计" },
      { id: 2, name: "月统计" },
      { id: 3, name: "周统计" }
    ],

    clockInStatus: [
      { id: 0, name: "正常" },
      { id: 1, name: "迟到" },
      { id: 2, name: "上班未打卡" },
      { id: 3, name: "早退" },
      { id: 4, name: "下班未打卡" },
      { id: 5, name: "缺勤" }
    ],

    // 请假类型
    typeLeave: [
      { id: 0, name: "事假" },
      { id: 1, name: "病假" }
    ],

    // 请假状态
    leaveStatus: [
      { id: 0, name: "请假待审批" },
      { id: 1, name: "审批通过" },
      { id: 2, name: "驳回" }
    ],

    // 请假条审核状态
    leaveAuditStatus: [
      { id: 1, name: "审批通过" },
      { id: 2, name: "驳回" },
      { id: 0, name: "转审" }
    ],

    // 问卷调查状态
    investigationStatus: [
      { id: 0, name: "未发布" },
      { id: 1, name: "已发布" }
    ],

    // 问卷调查问题类型
    optionType: [
      { id: 0, name: "单选题" },
      { id: 1, name: "多选题" },
      { id: 2, name: "填空题" },
      { id: 3, name: "附件上传" }
    ],

    // 机构状态
    institutionStatus: [
      { id: 0, name: "启用" },
      { id: 1, name: "禁用" }
    ],

    // 角色状态
    roleStatus: [
      { id: 0, name: "禁用" },
      { id: 1, name: "启用" }
    ],

    // 报修状态
    repairStatus: [
      { id: 1, name: "已上报" },
      { id: 2, name: "已指派" },
      { id: 3, name: "已处理" },
      { id: 4, name: "已验收" },
      { id: 5, name: "已过期" },
      { id: 6, name: "已撤销" }
    ],

    // 证件类型
    certificateType: [
      { id: 1, name: "身份证" },
      { id: 2, name: "军官证" },
      { id: 3, name: "护照" }
    ],

    // 证件类型二
    certificateTypeTwo: [
      { id: 1, name: "身份证" },
      { id: 2, name: "驾驶证" },
      { id: 3, name: "军官证" },
      { id: 4, name: "护照" }
    ],

    // 环测设备报警类型
    emAlarmTypeList:[
      { id: 0, name: "市电断电" },
      { id: 1, name: "电源输出电流过载 " },
      { id: 2, name: "电源输出电压过载" },
      { id: 3, name: "电源输入断电" },
      { id: 4, name: "水侵报警" },
      { id: 5, name: "温度过载" },
      { id: 6, name: "湿度过载" },
      { id: 7, name: "IO输入报警" },
      { id: 8, name: "USB异常插拔" },
      { id: 9, name: "电线温度过载" },
      { id: 10, name: "设备硬盘故障" },
      { id: 11, name: "设备CPU故障" }
    ],

    // 环测设备品牌 
    emDeviceBrandList:[
      { id: 0, name: "ty" },
    ],
  },
  mutations: {},
  actions: {},
  getters: {}
};
